import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import api, { formatINR } from "../../lib/api";
import { LayoutDashboard, ShoppingBag, FileText, Receipt, LogOut, Tag, KeyRound } from "lucide-react";
import InstallPWA from "../../components/InstallPWA";
export default function DistributorLayout() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        api.get("/distributors/me").then(r => setProfile(r.data)).catch(() => {});
    }, []);

    if (user && user.role !== "distributor") return <div className="p-12 text-center">Distributor login required</div>;

    const NAV = [
        { to: "/distributor", icon: LayoutDashboard, label: "Dashboard", end: true },
        { to: "/distributor/shop", icon: ShoppingBag, label: "Shop" },
        { to: "/distributor/price-list", icon: Tag, label: "Price list" },
        { to: "/distributor/orders", icon: FileText, label: "My Orders" },
        { to: "/distributor/invoices", icon: Receipt, label: "Invoices" },
        { to: "/distributor/statement", icon: Receipt, label: "Statement" },
    ];

    return (
        <div className="min-h-screen bg-stone-100" data-testid="distributor-layout">
            <header className="bg-white border-b border-stone-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <span className="w-8 h-8 grid place-items-center bg-sky-700 text-stone-50 font-serif">H</span>
                        <div className="leading-tight">
                            <div className="font-serif text-lg">Distributor Portal</div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-stone-500">{profile?.business_name || ""}</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        {profile && (
                            <span className={`text-[10px] tracking-widest uppercase px-2 py-1 border ${profile.status === "approved" ? "border-sky-700 text-sky-700" : profile.status === "pending" ? "border-amber-600 text-amber-700" : "border-red-600 text-red-700"}`} data-testid="dist-status">
                                {profile.status}
                            </span>
                        )}
                        <button onClick={() => { logout(); nav("/"); }} className="text-sm text-stone-700 hover:text-sky-700 flex items-center gap-1" data-testid="dist-logout">
                            <LogOut className="w-4 h-4" />Sign out
                        </button>
                    </div>
                </div>
            </header>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-12 gap-8">
                <aside className="col-span-12 md:col-span-3">
                    <nav className="bg-white border border-stone-200">
                        {NAV.map(n => (
                            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 text-sm border-b border-stone-100 last:border-b-0 ${isActive ? "bg-sky-50 text-sky-700 border-l-2 border-l-sky-700" : "text-stone-700 hover:bg-stone-50"}`} data-testid={`dist-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}>
                                <n.icon className="w-4 h-4" /> {n.label}
                            </NavLink>
                        ))}
                    </nav>
                    <div className="bg-white border border-stone-200 border-t-0 p-4">
                        <div className="text-[10px] uppercase tracking-widest text-stone-500 mb-1">Signed in as</div>
                        <div className="text-xs text-stone-700 truncate mb-3" title={user?.email}>{user?.email}</div>
                        <NavLink
                            to="/account/change-password"
                            className="w-full text-xs text-stone-700 hover:text-sky-700 flex items-center justify-center gap-2 px-3 py-2 border border-stone-300 hover:border-sky-700 transition-colors mb-2"
                            data-testid="dist-change-password"
                        >
                            <KeyRound className="w-3.5 h-3.5" /> Change password
                        </NavLink>
                        <button
                            onClick={() => { logout(); nav("/login"); }}
                            className="w-full text-xs text-stone-700 hover:text-sky-700 flex items-center justify-center gap-2 px-3 py-2 border border-stone-300 hover:border-sky-700 transition-colors"
                            data-testid="dist-logout-sidebar"
                        >
                            <LogOut className="w-3.5 h-3.5" /> Sign out
                        </button>
                    </div>
                </aside>
                <main className="col-span-12 md:col-span-9">
                    <Outlet context={{ profile }} />
                </main>
            </div>
            <InstallPWA />
        </div>
    );
}
